function darkMode() {
  const theme = localStorage.getItem('theme');
  const darkThemeIsSet = document.body.classList.contains('dark');
  const checkIsDarkSchemePreferred = window.matchMedia(
    '(prefers-color-scheme: dark)'
  ).matches;
  
  if (theme) {
    if ( theme === 'dark') {
      document.body.classList.add('dark');
    }
    else {
      document.body.classList.remove('dark');
    }
  } 
  else if (checkIsDarkSchemePreferred) {
    document.body.classList.add('dark');
  } 
  localStorage.setItem(
    'theme',
    document.body.classList.contains('dark') ? 'dark' : 'light'
  );
}

const toggleDarkMode = () => {
  document.body.classList.toggle('dark');
  localStorage.setItem(
    'theme',
    document.body.classList.contains('dark') ? 'dark' : 'light'
  );
};

darkMode()